import PageHeader from '@/components_legacy/common/PageHeader';
import Footer from '@/widgets/footer';

const GUIDELINES = [
  {
    title: 'Respect Boundaries',
    text: 'Everyone has different comfort levels, so please respect them. Avoid sharing nudity, explicit content, or sexual desires on your public profile.',
  },
  {
    title: 'Protect Personal Information',
    text: 'Share your personal information thoughtfully. Do not publicly display sensitive details like phone numbers or social media handles. Also, be wary of sharing or requesting financial information.',
  },
  {
    title: 'Avoid Violence',
    text: 'We promote positivity and do not tolerate any violent content, including depictions of harm or the use of weapons. If a situation suggests imminent danger, we will intervene with appropriate crisis resources.',
  },
  {
    title: 'Personal, Not Business',
    text: 'Bumpy is for personal connections, not commercial activities. Please do not use Bumpy for advertising, promoting businesses, or seeking financial support.',
  },
  {
    title: 'Authenticity is Key',
    text: 'Be genuine and avoid creating fake profiles or impersonating others. Authentic interactions form the best connections.',
  },
  {
    title: 'Communicate with Respect',
    text: 'Interacting with people from various backgrounds can be challenging. Maintain respect to ensure conversations remain pleasant and productive. We do not tolerate harassment or any form of bullying.',
  },
  {
    title: 'No Hate',
    text: 'Discrimination based on race, ethnicity, gender, or any other identity is strictly prohibited. If someone does not meet your preferences, simply move on without engagement.',
  },
  {
    title: 'Adult Community',
    text: 'Only individuals 18 years or older can use Bumpy. We strictly prohibit images of minors, even if they are photos of yourself from childhood.',
  },
  {
    title: 'Legal Compliance',
    text: 'All interactions on Bumpy must comply with the law. Illegal activities, including the sale of banned substances or counterfeit goods, are not allowed.',
  },
  {
    title: 'Your Space, Your Content',
    text: 'Only post content you own or have permission to share. Respect copyrights and privacy.',
  },
  {
    title: 'Community Integrity',
    text: 'Do not spread misinformation, create spam, or manipulate others. Use Bumpy honestly and responsibly.',
  },
];

const CommunityGuidelines = () => {
  return (
    <div className="relative top-0 overflow-auto">
      <PageHeader
        goBack={() => ''}
        withoutButton
        title="Comunity Guidelines"
        className="sticky top-0"
      />
      <div className="mt-10 mb-8 flex flex-col gap-1 px-12 sm:px-20">
        <p className="font-semibold text-4xl text-primary italic">
          Welcome to Bumpy!
        </p>
        <p>
          At Bumpy, we strive to create a welcoming, safe, and inclusive
          environment where you can be your true self and make meaningful
          connections. By adhering to these guidelines, you help us maintain
          this atmosphere and ensure a positive experience for all users.
        </p>
      </div>
      <ol className="flex flex-col gap-8 px-12 sm:px-20">
        {GUIDELINES.map((section, index) => (
          <li key={index}>
            <h2 className="font-bold text-xl">{`${index + 1}. ${section.title}`}</h2>
            <span>{section.text}</span>
          </li>
        ))}
      </ol>
      <div className="mt-16 flex flex-col gap-1 px-12 sm:px-20">
        <p className="font-semibold text-4xl text-primary italic">
          Reporting and Enforcement
        </p>
        <p>
          We encourage you to report any activities or behavior that violate
          these guidelines. We take each report seriously and will take
          appropriate actions to maintain community standards.
        </p>
        <p>
          By following these guidelines, you contribute to a trustworthy and
          engaging environment for all Bumpy users. Let's keep Bumpy a positive
          space for everyone!
        </p>
      </div>
      <Footer hasShadow />
    </div>
  );
};

export default CommunityGuidelines;
